import { number, object, string, union, z } from "zod";

export const UploadAttachResponseDTOError = object({
  error: string(),
});
export type UploadAttachResponseDTOError = z.infer<
  typeof UploadAttachResponseDTOError
>;

export const UploadAttachResponseDTOSuccess = object({
  id: number(),
  fileNameUrl: string(),
});
export type UploadAttachResponseDTOSuccess = z.infer<
  typeof UploadAttachResponseDTOSuccess
>;

export const UploadAttachResponseDTO = union([
  UploadAttachResponseDTOError,
  UploadAttachResponseDTOSuccess,
]);
export type UploadAttachResponseDTO = z.infer<typeof UploadAttachResponseDTO>;
